import { useLayoutEffect, useRef } from "react"
import { ChainEmitter, ChainPointStyled } from "./styled"
import BlockState from "pages/scheme-editor/store/block"
import { useSchemeEditorStore } from "pages/scheme-editor/store"

type Props = {
  state: BlockState,
  title: string,
  index: number
}

const ChainPoint = ({ state, title, index }: Props) => {

  const store = useSchemeEditorStore()
  const ref = useRef<HTMLButtonElement>(null)
  useLayoutEffect(() => {
    state.setChainPos(ref.current!, index)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  
  return (
    <ChainEmitter 
      onMouseDown={e => store.onChainPointClick(e, state.id, index)} 
      data-chain-index={index}
    >
      { title }
      <ChainPointStyled ref={ref}/>
    </ChainEmitter>
  )
}

export default ChainPoint